import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PaginationEmpty } from 'domain/models/queryPagination'
import { StudentStateType } from 'domain/models/student'
import {
  ReadPromotionStudentsQueryResponse,
  ReadStudentQueryResponse,
} from 'domain/entities/student'
import { RootState } from 'presentation/redux/reducers'

const initialState: StudentStateType = {
  error: null,
  errorsExcel: null,
  errorUpdate: null,
  isLoading: false,
  pagination: PaginationEmpty,
  students: [],
  student: null,
  isLoadingUpload: false,
}
export const studentSlice = createSlice({
  name: 'student',
  initialState,
  reducers: {
    getStudentsByPromotionStart: (state: StudentStateType) => {
      state.isLoading = true
      state.error = null
      state.errorsExcel = null
      state.errorUpdate = null
    },
    getStudentsByPromotionSuccess: (
      state: StudentStateType,
      action: PayloadAction<ReadPromotionStudentsQueryResponse>,
    ) => {
      state.isLoading = false
      state.students = action.payload.students
      state.pagination = action.payload.pagination
    },
    getStudentsByPromotionError: (state: StudentStateType, action: PayloadAction<string>) => {
      state.isLoading = false
      state.error = action.payload
    },
    updateStudentStateStart: (state: StudentStateType) => {
      state.isLoading = true
      state.error = null
      state.errorsExcel = null
      state.errorUpdate = null
    },
    updateStudentStateSuccess: (state: StudentStateType) => {
      state.isLoading = false
    },
    updateStudentStateError: (state: StudentStateType, action: PayloadAction<string>) => {
      state.isLoading = false
      state.error = action.payload
    },
    uploadStudentsStart: (state: StudentStateType) => {
      state.error = null
      state.errorsExcel = null
      state.errorUpdate = null
      state.isLoadingUpload = true
    },
    uploadStudentsSuccess: (state: StudentStateType) => {
      state.isLoadingUpload = false
    },
    uploadStudentsError: (state: StudentStateType, action: PayloadAction<any>) => {
      state.errorsExcel = action.payload
      state.isLoadingUpload = false
    },
    updateStudentStart: (state: StudentStateType) => {
      state.isLoadingUpload = true
      state.error = null
      state.errorsExcel = null
      state.errorUpdate = null
    },
    updateStudentSuccess: (state: StudentStateType) => {
      state.isLoadingUpload = false
    },
    updateStudentError: (state: StudentStateType, action: PayloadAction<string>) => {
      state.isLoadingUpload = false
      state.errorUpdate = action.payload
    },
    clearExcelError: (state: StudentStateType) => {
      state.errorsExcel = null
    },
    getStudentStart: (state: StudentStateType) => {
      state.isLoading = true
      state.error = null
      state.errorsExcel = null
      state.errorUpdate = null
      state.student = null
    },
    getStudentSuccess: (
      state: StudentStateType,
      action: PayloadAction<ReadStudentQueryResponse>,
    ) => {
      state.isLoading = false
      state.student = action.payload
    },
    getStudentError: (state: StudentStateType, action) => {
      state.isLoading = false
      state.error = action.payload
    },
  },
})

export const studentState = (state: RootState) => state.student
export const {
  getStudentsByPromotionStart,
  getStudentsByPromotionSuccess,
  getStudentsByPromotionError,
  updateStudentStateSuccess,
  updateStudentStateStart,
  updateStudentStateError,
  uploadStudentsStart,
  uploadStudentsSuccess,
  uploadStudentsError,
  updateStudentStart,
  updateStudentSuccess,
  updateStudentError,
  clearExcelError,
  getStudentError,
  getStudentSuccess,
  getStudentStart,
} = studentSlice.actions

export default studentSlice.reducer
